import { HStack } from '@chakra-ui/react';
import { ICartItem } from '@/_store/types';
import ProductThumbnail from './ProductThumbnail';
import AdditionalProductsCard from './AdditionalProductsCard';

interface ProductThumbnailsProps {
  products: ICartItem[];
  maxVisible?: number;
}

export default function ProductThumbnails({
  products,
  maxVisible = 5,
}: ProductThumbnailsProps) {
  const visibleProducts = products.slice(0, maxVisible);
  const additionalCount = products.length - maxVisible;

  return (
    <HStack gap={1} flexWrap='wrap' justify='center'>
      {visibleProducts.map((item) => (
        <ProductThumbnail
          key={item.key}
          cartItem={item}
        />
      ))}
      <AdditionalProductsCard count={additionalCount} />
    </HStack>
  );
}
